import ExcelJS from 'exceljs';

// The Board Making Plan as the factory's own sheet (same columns as his Excel), for printing or as an .xlsx file.

const dmy = (d) => (d ? `${d.slice(8, 10)}.${d.slice(5, 7)}.${d.slice(2, 4)}` : '');
const r1 = (n) => Math.round((Number(n) || 0) * 10) / 10;

export const measurementText = (j) => {
    const parts = [j.Length, j.Width, j.Height].map((v) => Number(v) || 0);
    const shown = parts[2] ? parts : parts.slice(0, 2);
    return `${shown.join('x')} ${j.Unit || ''}`.trim();
};

// One row per job, in plan order (grouped by roll size)
export function sheetRows(jobs, paperName, positions) {
    return jobs.filter((j) => !Number(j.IsHold)).map((j, i) => {
        const qty = Number(j.PlannedQty) || 0;
        const setting = Number(j.Setting) || 1;
        const sqm = qty * (Number(j.sqmPerPiece) || 0);
        const rollM = (Number(j.RollSize) || 0) * 0.0254;
        const paper = positions.filter((p) => j.papers?.[p.Code]).map((p) => `${p.Code}:${paperName(j.papers[p.Code])}`).join(' | ');
        return {
            sl: i + 1,
            job: j.JobNumber || '',
            client: j.PartyName || '',
            buyer: j.BuyerName || '',
            item: j.ItemName || '',
            rollSize: j.RollSize ?? '',
            setting,
            boardQty: Math.ceil(qty / setting),
            L: Number(j.Length) || '',
            W: Number(j.Width) || '',
            H: Number(j.Height) || '',
            unit: j.Unit || '',
            ply: j.Part ? `${j.Specification || ''} (${j.Part}-ply part)`.trim() : j.Specification || '',
            qty,
            runningM: rollM > 0 ? r1(sqm / rollM) : '',
            sqm: r1(sqm),
            paper,
        };
    });
}

const HEAD = ['SL', 'WO/NO', 'Client', 'PO/Buyer', 'Item', 'Roll Size', 'Setting', 'Board Qty', 'L', 'W', 'H', 'Unit', 'PLY', 'Items Qty (Pcs)', 'Total Running Mtr', 'Total SQM', 'PAPER GRADE'];
const cells = (r) => [r.sl, r.job, r.client, r.buyer, r.item, r.rollSize, r.setting, r.boardQty, r.L, r.W, r.H, r.unit, r.ply, r.qty, r.runningM, r.sqm, r.paper];

export function printSheet(date, rows) {
    const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const totalSqm = r1(rows.reduce((s, r) => s + (Number(r.sqm) || 0), 0));
    const totalRun = r1(rows.reduce((s, r) => s + (Number(r.runningM) || 0), 0));
    let lastSize = null;
    const body = rows.map((r) => {
        const sep = lastSize !== null && r.rollSize !== lastSize ? ' class="sep"' : '';
        lastSize = r.rollSize;
        return `<tr${sep}>${cells(r).map((c) => `<td>${esc(c)}</td>`).join('')}</tr>`;
    }).join('');
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Board Making Plan ${esc(dmy(date))}</title>
<style>body{font-family:Arial,sans-serif;font-size:11px;margin:12px}h3{margin:0 0 8px}table{border-collapse:collapse;width:100%}
th,td{border:1px solid #444;padding:3px 4px;text-align:left}th{background:#d1e7dd}tr.sep td{border-top:3px solid #000}
tfoot td{font-weight:bold}@media print{@page{size:A4 landscape;margin:8mm}}</style></head>
<body><h3>Board Making Plan — ${esc(dmy(date))}</h3><table><thead><tr>${HEAD.map((h) => `<th>${h}</th>`).join('')}</tr></thead>
<tbody>${body}</tbody><tfoot><tr><td colspan="14">Total</td><td>${totalRun}</td><td>${totalSqm}</td><td></td></tr></tfoot></table>
<script>window.onload=function(){window.print();}</script></body></html>`;
    const w = window.open('', '_blank');
    if (!w) return false;
    w.document.write(html);
    w.document.close();
    return true;
}

export async function downloadSheet(date, rows) {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet(dmy(date).replace(/\./g, '-') || 'Plan');
    ws.addRow(['', '', '', dmy(date)]);
    const head = ws.addRow(HEAD);
    head.font = { bold: true };
    head.eachCell((c) => { c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD1E7DD' } }; });
    rows.forEach((r) => ws.addRow(cells(r)));
    ws.addRow([]);
    ws.addRow(['', '', '', '', '', '', '', '', '', '', '', '', '', 'Total',
        r1(rows.reduce((s, r) => s + (Number(r.runningM) || 0), 0)),
        r1(rows.reduce((s, r) => s + (Number(r.sqm) || 0), 0))]).font = { bold: true };
    [5, 13, 18, 16, 8, 9, 8, 9, 7, 7, 7, 6, 7, 12, 12, 10, 40].forEach((w, i) => { ws.getColumn(i + 1).width = w; });
    const buffer = await wb.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Board_Making_Plan_${date}.xlsx`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
}
